import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { enquiryService } from "./dtpService";
import { globalPrompt } from "@/components/message";
import { useGlobalModel, transPgToPagination } from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { ISearchPage } from "@/types/AppTypes";
import { IDtpDetail, IDtpSearchFields } from "./dtpTypes";

export const useDtpModel = createModel(function () {
    const { user: { shopCode }, setLoadingInfo } = useGlobalModel(({ user }) => [user]);
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IDtpDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IDtpSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选code值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);


    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IDtpSearchFields = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await enquiryService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IDtpSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    //导出
    const exportDtp = async (searchValue: IDtpSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const searchParams = {
                shopCode,
                ...searchValue,
                // singleCode: selectedRowKeys?.join(),
                // pageSize: -1,
                // pageNum: 1,
            };

            let result = await enquiryService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }


    //启用 禁用 api
    const disableDtp = async (id: string) => {
        let { retData } = await enquiryService.disable(id);
        loadData()
        globalPrompt("message", { text: "作废成功", type: "success" })
    };

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        loading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportDtp,
        disableDtp,
    }
});